import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
var itemType = {};
(document.getElementById("output") as HTMLTextAreaElement).value = "";
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI.getTree().then((_tree) => {
      LwAPI?.registerOnSelection(function (selectedItem) {
        if (selectedItem.item != null) {
          var mid = selectedItem.item.modelId;
          var iid = selectedItem.item.modelItemId;
          LwAPI?.searchTreeItem(mid + ":" + iid, getItemType())
            .then(function (treeItem) {
              (document.getElementById("output") as HTMLTextAreaElement).value =
                "Current selection:" +
                "\nModel ID: " +
                mid +
                "\nItem ID: " +
                iid +
                "\nItem name: " +
                treeItem.text +
                "\nItem type: " +
                treeItem.type +
                "\nBounding box: \n" +
                JSON.stringify(treeItem.bbox, null, "  ");
            })
            .catch(function (err) {
              alert("searchTreeItem returned a message:\n" + err);
            });
        } else {
          (document.getElementById("output") as HTMLTextAreaElement).value =
            "Nothing selected.";
        }
      });
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function getItemType() {
  return itemType;
}
// Bind functions to buttons
document.getElementById("all")?.addEventListener("click", async () => {
  await apiReady;
  itemType = {};
});
document.getElementById("assembly")?.addEventListener("click", async () => {
  await apiReady;
  itemType = { type: "assembly" };
});
document.getElementById("part")?.addEventListener("click", async () => {
  await apiReady;
  itemType = { type: "part" };
});
document.getElementById("model")?.addEventListener("click", async () => {
  await apiReady;
  itemType = { type: "model" };
});
